import $ from 'jquery'

function init() {}
function ready() {
  const $button = $('.js-clear-checkbox')
  $button.each((_, button) => {
    $(button).on('click', (e) => {
      const targetInputName = $(e.target).attr('data-clear-target')
      const $targets = $(`input[name="${targetInputName}"]`)
      $targets.each((_, el) => {
        $(el).removeAttr('checked').prop('checked', false).change()
      })
    })
  })
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
